import { isFunction } from 'lodash-es';
import screenfull from 'screenfull';
import type UAParser from 'ua-parser-js';
import { themeOverrides } from '../themeOverrides.ts';
import { isDeviceMobile } from './uaParser.ts';

let inFullScreen = false;

export const supported = (uaParser: UAParser.IResult) => {
  const isMobile = isDeviceMobile(uaParser);
  const supportsLock = 'lock' in window.screen.orientation && isFunction(window.screen.orientation.lock);
  const isSmall = globalThis.matchMedia(`(max-width: ${String(themeOverrides.breakpoints.values.sm - 1)}px)`).matches;
  const isMobileInPortrait = isSmall && isMobile;
  const isMobileInLandscape = globalThis.outerHeight < globalThis.outerWidth && isMobile;
  return (isMobileInPortrait || isMobileInLandscape) && supportsLock && screenfull.isEnabled;
};

export const enable = async (uaParser: UAParser.IResult) => {
  if (supported(uaParser) && !inFullScreen) {
    try {
      await screenfull.request();
      inFullScreen = true;
      // @ts-expect-error property is missing from lib definition.
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      await window.screen.orientation.lock(window.screen.orientation.type);
    } catch {
      // no catch
    }
  }
};

export const disable = async (uaParser: UAParser.IResult) => {
  if (supported(uaParser) && inFullScreen) {
    try {
      await screenfull.exit();
      inFullScreen = false;
      window.screen.orientation.unlock();
    } catch {
      // no catch
    }
  }
};
